module.exports = __webpack_public_path__ + "img/logo.785ae227.png";